import React from 'react';
import { useLandingContent } from '../../context/LandingContentContext';

const DEFAULT_USPS = [
  { text: 'DEIN PARTNER für Software- & Hardwareoptimierungen' },
  { text: 'Ratenzahlung über PayPal und Klarna!' },
  { text: 'WIR stehen für Kundenservice', link: '/kontakt' },
  { text: 'Kundenzufriedenheit ist unser Ziel' },
  { text: 'Liked gerne bei Facebook & Instagram' },
];

const USPBanner = () => {
  const lc = useLandingContent();
  const [current, setCurrent] = React.useState(0);

  const usps = DEFAULT_USPS.map((d, i) => ({
    text: lc[`usp_banner_${i + 1}`] || d.text,
    link: d.link,
  }));

  React.useEffect(() => {
    const timer = setInterval(() => setCurrent(c => (c + 1) % usps.length), 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="usp-banner" data-testid="usp-banner">
      <div className="usp-banner-inner">
        {usps.map((usp, i) => (
          <span key={i} className={`usp-item ${i === current ? 'active' : ''}`}>
            {usp.link ? (
              <a href={usp.link}>{usp.text}</a>
            ) : (
              usp.text
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default USPBanner;
